// src/components/intake/IntakeCountField.js
//
// Ticket 061. A "how many" question that can tell "none" from "skipped":
// the "None" button stores a confirmed zero, a number of 1 or more stores that
// number, and an empty field stores nothing. (The Calculator's blank-means-0 box
// is deliberately not reused.) `max` caps a sub-count at its total.

import React from 'react'
import { NONE_LABEL } from '../../lib/intake/intakeConfig'
import { known, none } from '../../lib/intake/section1Facts'

export default function IntakeCountField({ id, label, fact, onChange, max }) {
  const isZero = !!fact && fact.status === 'known_zero'
  const shown = fact && fact.status === 'known_value' ? String(fact.value) : ''

  function handleType(e) {
    const raw = e.target.value
    if (raw === '') { onChange(null); return }
    const n = Math.floor(Number(raw))
    if (!Number.isFinite(n) || n < 1) return
    onChange(known(max ? Math.min(n, max) : n))
  }

  return (
    <div className="intake-count-row">
      <label className="u-form-label" htmlFor={id}>{label}</label>
      <div className="intake-count-controls">
        <button
          type="button"
          className={`triage-subquestion-opt${isZero ? ' selected' : ''}`}
          onClick={() => onChange(none())}
          aria-pressed={isZero}
        >
          {NONE_LABEL}
        </button>
        <input
          id={id}
          type="number"
          min="1"
          max={max || undefined}
          inputMode="numeric"
          className="app-input intake-count-input"
          placeholder="Number"
          value={shown}
          onChange={handleType}
        />
      </div>
    </div>
  )
}
